<template>
  <div class="about">
    <div class="about-header-wrap">
      <app-header theme="transparent"/>
    </div>

    <div class="top-section-slider-wrap">
      <agile :options="sliderOptions" :prevArrow="sliderArrowPrev" :nextArrow="sliderArrowNext">
        <div class="top-section slider-item2">
          <div class="top-section-gradient">
            <div class="container">
              <div class="row align-items-center top-section-slider">
                <div class="col-12">
                  <div class="slider__wrap">
                    <div class="image-container slider__img">
                      <img src="@/assets/sliderImg.png">
                    </div>
                    <div class="slider__text">
                      ТОО “СК-Грант” реализует щебень фракционный (радиоактивность 1 класса, качество 1 класса)
                      ГОСТ 8267-93, из карьера «Золоторунный» (Тайыншинский район, Северо-Казахстанская область).
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="scroll-button" @click="scrollNextScreen">
              <img src="@/assets/arrowDown.png">
              <span class="scroll-button__text">Прокрутите вниз</span>
            </div>
          </div>
        </div>

        <div class="top-section slider-item3">
          <div class="top-section-gradient">
            <div class="container">
              <div class="row align-items-center top-section-slider">
                <div class="col-12">
                  <div class="slider__wrap">
                    <div class="image-container slider__img">
                      <img src="@/assets/sliderImg.png">
                    </div>
                    <div class="slider__text">
                      ТОО “СК-Грант” реализует щебень фракционный (радиоактивность 1 класса, качество 1 класса)
                      ГОСТ 8267-93, из карьера «Золоторунный» (Тайыншинский район, Северо-Казахстанская область).
                      <!--
                      Лидер производства щебня в Северо-Казахстанской области.
                      Наша компания, не раз подтверждала репутацию
                      добросовестного и ответственного делового партнера
                      по вопросам поставки щебня.
                      -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="scroll-button" @click="scrollNextScreen">
              <img src="@/assets/arrowDown.png">
              <span class="scroll-button__text">Прокрутите вниз</span>
            </div>
          </div>
        </div>
      </agile>
    </div>

    <div class="container fulldescription">
      <div class="row align-items-center">
        <div class="col-md-6 fulldescription__left-block">
          <div class="fulldescription__top-section" data-aos="zoom-out">
            <img src="@/assets/addBtn.png">
            Мы предлагаем:
          </div>
          <!--
          <div class="fulldescription__main-section">
            <div class="fulldescription__title">
              <span class="fulldescription__title-sk">СК </span>
              <span class="fulldescription__title-grant">ГРАНТ</span>
            </div>
            <div class="fulldescription__text">
              Мы работаем на рынке Казахстана более 10 лет
              и являемся проверенным и надежным 
              производителем щебня.
            </div>
            <div class="fulldescription__footer">
              Реализуем оптом и в розницу. 
            </div>
            <div class="fulldescription__catalog-btn-wrap">
              <router-link :to="{name: 'home'}">
                <ButtonSlider msg="Каталог продукции" :wide="true" />
              </router-link>
            </div>
          </div> 
          -->
          <ul class="fulldescription-list">
            <li class="fulldescription-list__item" data-aos="zoom-out" data-aos-delay="200">
              Мелкая фракция 5-20. Основное предназначение: производство бетона,
              асфальта, железобетонных конструкций, отсыпка дорожек
              на приусадебных участках, укладка и ремонт дорог.
            </li>
            <li class="fulldescription-list__item" data-aos="zoom-out" data-aos-delay="350">
              Средняя фракция 20-40. Самая востребованная фракция, более доступная в ценовой категории,
              используется для строительства жилых домов,
              сооружений, зданий, для отсыпки дорожного полотна с низкой нагрузкой.
            </li>
            <li class="fulldescription-list__item" data-aos="zoom-out" data-aos-delay="500">
              Крупная фракция 40-70. Идеально подходит для создания дорожного покрытия с высокой несущей способностью.
              Используется для создания подъездных путей для тяжеловесной техники, либо если необходима площадка с прочным и твердым покрытием.
            </li>
            <li class="fulldescription-list__item" data-aos="zoom-out" data-aos-delay="650">
              Песчано гравийная смесь (0-5, 0-10 ). Используется для производства очень качественных железобетонных изделий,
              а так же широко используется в жилищном и в дорожном строительстве,
              где пгс применяется для приготовления асфальтобетонных смесей и укладки дорог.
            </li>
          </ul>
        </div>

        <div class="col-md-6 fulldescription__slider">
          <!--
          <div class="image-container">
            <img src="@/assets/fulldescr.png" />
          </div>
          -->
          <agile :options="fullDescSliderOptions">
            <div class="image-container">
              <img src="@/assets/fulldescr1.jpg">
            </div>
            <div class="image-container">
              <img src="@/assets/fulldescr2.jpg">
            </div>
            <div class="image-container">
              <img src="@/assets/fulldescr3.jpg">
            </div>
            <div class="image-container">
              <img src="@/assets/fulldescr4.jpg">
            </div>
          </agile>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row align-items-center advantages">
        <div class="col-md-6 col-lg-3 advantages__item-wrap" data-aos="zoom-in">
          <div class="advantages__title">ПРЕИМУЩЕСТВА РАБОТЫ С НАМИ</div>
          <div class="image-container">
            <img src="@/assets/advantages.png">
          </div>
        </div>

        <div class="col-md-6 col-lg-3 advantages__item-wrap" data-aos="zoom-in" data-aos-delay="50">
          <div class="advantages__item-header">
            <img src="@/assets/quality.png">
            <span class="advantages__name">КАЧЕСТВО</span>
          </div>
          <div
            class="advantages__item-body"
          >Компания СК-ГРАНТ - реализует фракционный щебень, первого класса</div>
        </div>

        <div
          class="col-md-6 col-lg-3 advantages__item-wrap"
          data-aos="zoom-in"
          data-aos-delay="100"
        >
          <div class="advantages__item-header">
            <img src="@/assets/shipment.png">
            <span class="advantages__name">ОТГРУЗКА</span>
          </div>
          <div
            class="advantages__item-body"
          >Наша компания осуществляет бесплатную погрузку в открытые машины.</div>
        </div>

        <div
          class="col-md-6 col-lg-3 advantages__item-wrap"
          data-aos="zoom-in"
          data-aos-delay="150"
        >
          <div class="advantages__item-header">
            <img src="@/assets/price.png">
            <span class="advantages__name">ЦЕНА</span>
          </div>
          <div
            class="advantages__item-body"
          >Мы всегда готовы предоставить актуальную цену, на рынке Казахстана.</div>
        </div>
      </div>
    </div>

    <div class="mission" v-if="false">
      <div class="container mission__wrap">
        <div class="row align-items-center">
          <div class="col-md-4" data-aos="zoom-in-down">
            <div
              class="mission__slogan"
            >МЫ БЕРЕМ НА СЕБЯ ОТВЕТСТВЕННОСТЬ ЗА РЕЗУЛЬТАТ И ДАЕМ ГАРАНТИИ НА НАШ ПРОДУКТ</div>
            <div class="mission__title">Миссия</div>
          </div>
        </div>
        <div class="row mission__text-wrap">
          <div class="col-md-4 mission__text" data-aos="zoom-in" data-aos-delay="50">
            Своевременно и бесперебойно обеспечивать наших клиентов высококачественным бетоном,
            раствором и железобетонными изделиями, гарантируя исключительный сервис и
            сохраняя многолетнюю безупречную репутацию надежного поставщика.
          </div>
          <div class="col-md-4 mission__text" data-aos="zoom-in" data-aos-delay="100">
            Мы контролируем технические процессы и качественные характеристики входящих материалов
            для получения качественной продукции!
          </div>
          <div class="col-md-4 mission__text" data-aos="zoom-in" data-aos-delay="150">Наши принципы:
            <br>- Снабжение клиентов только качественными и долговечными строительными материалами.
            <br>- Обеспечение широким выбором товара.
            <br>- Оперативность доставки и гибкость логистики.
            <br>- Индивидуальный подход для максимального удовлетворения потребностей заказчика.
          </div>
        </div>
      </div>
    </div>

    <div class="certificates-section">
      <div class="container">
        <div class="row align-items-center certificates-wrap">
          <div class="col-12">
            <div class="certificates-subtitle">КАЧЕСТВО ПОДТВЕРЖДЕНО СЕРТИФИКАТАМИ</div>
            <div class="certificates-title">СЕРТИФИКАТЫ</div>
          </div>

          <div class="col-12">
            <div class="certificates-swiper-wrap">
              <swiper :options="certificatesSwiperOption" ref="certificatesSwiper">
                <swiper-slide v-for="(certificate, index) in certificates" :key="index">
                  <a class="image-container" :href="certificate.filename" target="_blank">
                    <img :src="certificate.smallImg">
                  </a>
                </swiper-slide>
              </swiper>

              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
              <div class="swiper-button-divider"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-header theme="footer"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import ButtonSlider from "@/components/ButtonSlider.vue";
import SideMenu from "@/components/SideMenu.vue";

import axios from "axios";

import { mapGetters } from "vuex";

export default {
  name: "About",
  components: {
    "app-header": Header,
    SideMenu,
    ButtonSlider
  },
  data() {
    return {
      sliderArrowNext:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.09 19.766"><defs><style>.cls-1 {fill: none;stroke: #fff;stroke-width: 2px;} #Group_16 {opacity: 0.5} #Group_16:hover {opacity: 1}</style></defs><g id="Group_35" data-name="Group 35" transform="translate(-1553.911 -540.16)"><path id="Path_72" data-name="Path 72" class="cls-1" d="M1603.051,1731.445l9.176-9.176-9.176-9.176" transform="translate(-26.639 -1172.227)"/><path id="Path_73" data-name="Path 73" class="cls-1" d="M1620.386,1747.043H1588.71" transform="translate(-34.799 -1197)"/></g></svg>',
      sliderArrowPrev:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.09 19.766"><defs><style>.cls-1 {fill: none;stroke: #fff;stroke-width: 2px;} #Group_35 {opacity: 0.5} #Group_35:hover {opacity: 1}</style></defs><g id="Group_16" data-name="Group 16" transform="translate(1643.414 559.926) rotate(-180)"><path id="Path_70" data-name="Path 70" class="cls-1" d="M1603.051,1731.445l9.176-9.176-9.176-9.176" transform="translate(29.773 -1172.227)"/><path id="Path_71" data-name="Path 71" class="cls-1" d="M1620.386,1747.043H1588.71" transform="translate(21.614 -1197)"/></g></svg>',
      sliderOptions: {
        arrows: true,
        dots: false,
        autoplaySpeed: 10000,
        speed: 750,
        timing: "ease-in-out",
        fade: true,
        autoplay: true,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 993,
            settings: {
              //arrows: true,
            }
          }
        ]
      },
      fullDescSliderOptions: {
        arrows: false,
        dots: true,
        autoplaySpeed: 750,
        speed: 750,
        timing: "ease-in-out",
        fade: true,
        autoplay: true,
        pauseOnHover: false
      },
      certificatesSwiperOption: {
        slidesPerView: 5,
        spaceBetween: 30,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          476: {
            slidesPerView: 1,
            centeredSlides: true
          },
          768: {
            slidesPerView: 2
          },
          992: {
            slidesPerView: 3
          },
          1200: {
            slidesPerView: 4
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters("certificates", ["certificates"]),
    swiper() {
      return this.$refs.certificatesSwiper.swiper;
    }
  },
  methods: {
    scrollNextScreen() {
      window.scroll({
        left: 0,
        top: document.documentElement.clientHeight,
        behavior: "smooth"
      });
    },
    showFile(blob) {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([blob], { type: "application/pdf" });

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement("a");
      link.href = data;
      link.download = "file.pdf";
      link.click();
      setTimeout(function() {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    downloadFile(filename) {
      axios({
        url: `/files/${filename}`,
        method: "GET",
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        setTimeout(function() {
          link.remove();
          window.URL.revokeObjectURL(url);
        }, 1000);
      });
    }
  }
};
</script>

